import ContentCard from "@components/ui/ContentCard";
import "./MethodologyPage.css";
import MethodologyPDF from "@assets/files/Methodology.pdf";

/**
 * Methodology page component displaying methodology information and research papers
 * @returns {JSX.Element}
 */
const MethodologyPage = () => {
  return (
    <div className="methodology-page">
      <section className="hero-methodology">
        <div className="container hero-content">
          <h1 className="page-title">Methodology</h1>
        </div>
      </section>

      <section className="methodology-content">
        <div className="container">
          <div className="creative-layout">
            <ContentCard
              icon="📑"
              title="ISCRI Methodology"
              animationDelay={0.1}
              actionLabel="📄 Download Methodology Note"
              actionHref={MethodologyPDF}
              actionDownload="ISCRI_Methodology.pdf"
              actionTarget="_blank"
            >
              <p className="content-card__text">
                <strong>The ISCRI indicator</strong> can be understood as the
                cumulative outcomes of past interstate conflictual events: a
                stock fed by flows of conflictual events.
                <br />
                For the full methodology, please see our methodology note.
              </p>
              <p className="content-card__text">
                Working papers exploiting the ISCRI will be posted here soon.
              </p>
            </ContentCard>

            <ContentCard
              icon="🗃️"
              title="Data Sources"
              animationDelay={0.2}
            >
              <p className="content-card__text">
                ISCRI is based on the automatic coding of media news recorded
                in the
                <strong>
                  {" "}
                  Global Data on Events, Location, and Tone (GDELT)
                </strong>{" "}
                database.
              </p>
              <ul className="content-card__list content-card__list--check">
                <li>Real-time media analysis</li>
                <li>Global coverage since 1980</li>
                <li>Automated event coding</li>
                <li>Comprehensive source validation</li>
              </ul>
            </ContentCard>

            <ContentCard
              icon="⚙️"
              title="Technical Approach"
              animationDelay={0.3}
            >
              <p className="content-card__text">
                The ISCRI follows best practices in geopolitical risk
                measurement and distinguishes between:
              </p>
              <div className="content-card__sub-cards">
                <div className="content-card__sub-card">
                  <h4 className="content-card__sub-title">
                    💬 Verbal Conflicts
                  </h4>
                  <p className="content-card__sub-text">
                    Spoken criticism, threats, or accusations often related to
                    past or future potential acts of material conflict.
                  </p>
                </div>
                <div className="content-card__sub-card">
                  <h4 className="content-card__sub-title">
                    ⚔️ Material Conflicts
                  </h4>
                  <p className="content-card__sub-text">
                    Physical acts of conflictual nature including force
                    posture, coercion, assault, and mass violence.
                  </p>
                </div>
              </div>
            </ContentCard>

            <ContentCard
              icon="✉️"
              title="Research Collaboration"
              animationDelay={0.4}
              actionLabel="Contact Research Team"
              actionHref="mailto:rodolphe.desbordes@skema.edu"
            >
              <p className="content-card__text">
                Interested in collaborating or have questions about the
                methodology? Contact our research team for more information.
              </p>
            </ContentCard>
          </div>
        </div>
      </section>
    </div>
  );
};

export default MethodologyPage;
